import React from "react";
import { useAuthorization } from "../../auth/useAuthorization";
import { MicHeroIcon } from "../../icons";
import { VOICE_OPTIONS } from "../../constants";
import "./VoicePreferencesPage.scss";

function VoicePreferencesPage() {
  const { role } = useAuthorization();

  return (
    <div className="vp-page">
      {/* ── Page header ── */}
      <div className="vp-page-header">
        <MicHeroIcon className="vp-hero-icon" />
        <div className="vp-page-header__text">
          <h1 className="vp-page-header__title">Voice Preferences</h1>
          <p className="vp-page-header__subtitle">
            Configure the default voice engine and language used during AV synchronisation.
          </p>
        </div>
        {/* Admin role badge */}
        <span className="vp-role-badge" aria-label={`Current role: ${role}`}>
          {role}
        </span>
      </div>

      {/* ── Settings card ── */}
      <div className="vp-card">
        <h2 className="vp-card__section-title">Available Voice Profiles</h2>
        <p className="vp-card__section-desc">
          Select the default voice profile applied to all new synchronisation jobs. Changes take
          effect on the next submitted job.
        </p>

        <ul className="vp-voice-list">
          {VOICE_OPTIONS.map((voice) => (
            <li key={voice.id} className="vp-voice-item">
              <label className="vp-voice-label">
                <input
                  type="radio"
                  name="voice-profile"
                  defaultChecked={voice.active}
                  className="vp-voice-radio"
                />
                <div className="vp-voice-info">
                  <span className="vp-voice-name">{voice.label}</span>
                  <span className="vp-voice-engine">{voice.engine}</span>
                </div>
                {voice.active && <span className="vp-voice-active-badge">Active</span>}
              </label>
            </li>
          ))}
        </ul>

        <div className="vp-card__actions">
          <button className="vp-btn vp-btn--secondary" type="button">
            Reset to Default
          </button>
          <button className="vp-btn vp-btn--primary" type="button">
            Save Preferences
          </button>
        </div>
      </div>

      {/* ── Info notice ── */}
      <div className="vp-notice" role="note">
        <strong>Admin only:</strong>&nbsp;This page is restricted to administrators. Voice
        preference changes apply globally across all user accounts.
      </div>
    </div>
  );
}

export default VoicePreferencesPage;
